<template>
  <div class="components-layout-demo-basic">
    <div class="teacher-overview-welcome">
      <div class="welcome">
        <p class="welcome-title">What is PlantCTCIP?</p>
        <p class="welcome-email">
          PlantCTCIP is a deep learning-based algorithmic framework for predicting multi-species
          chromatin proximal and distal interactions.PlantCTCIP can accurately predict chromatin
          interactions of both chromatin proximal and distal types in higher plants including maize,
          cotton, rice, and wheat. PlantCTCIP enables genome-wide predictions across species and
          further utilizes this ability to predict chromatin effects of sequence variants
          prioritizing regulatory variants.
        </p>
        <p class="welcome-email">
          PlantCTCIP can achieve the task of genome-wide prediction in different species. Meanwhile,
          based on the genome-wide prediction, it can visually display important region motifs
          affecting chromatin interactions, which can be further utilized to mine super-enhancers
          and reveal the gene-gene and gene-interval regulatory mechanisms.
        </p>
      </div>
    </div>

    <div class="top-text">
      <a-row type="flex" justify="left">
        <a-col :span="16">
          <img src="../img/homeBackImg.png" alt="Description of image" class="responsive-img" />
        </a-col>
        <a-col :span="1"></a-col>
        <a-col :span="7">
          <div class="img-select">
            <el-form label-position="top" class="img-select-form">
              <el-form-item>
                <template #label>
                  <span class="custom-label">Select models</span>
                </template>
                <el-select
                  v-model="selectedOption"
                  placeholder="------"
                  style="width: 100%"
                  @change="changeSelect()"
                >
                  <el-option
                    style="font-size: 18px; font-weight: bold"
                    v-for="option in options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <template #label>
                  <span class="custom-label">Query your results</span>
                </template>
                <el-input placeholder="Please input a task id" v-model="searchText">
                  <el-button @click="turn2Search()" slot="append" icon="el-icon-search"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item>
                <div>
                  <span class="example-text">Example task IDs:</span>
                  <br />
                  <span class="example-text2">5451_1714025386386</span>
                  <span style="font-size: 18px"> or</span>
                  <br />
                  <span class="example-text2">1329_1713791332244</span>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </a-col>
      </a-row>
    </div>

    <div class="tools-section">
      <el-row type="flex" justify="center" style="margin-bottom: 10px">
        <el-col :span="18">
          <p class="tools-title">Tools in this website:</p>
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="center">
        <el-col :span="6" class="tool-col">
          <el-card class="tool-card">
            <router-link to="/Expression/index">
              <h3>Predict</h3>
            </router-link>
            <p>Chromatin Interaction Prediction</p>
          </el-card>
        </el-col>
        <el-col :span="6" class="tool-col">
          <el-card class="tool-card">
            <router-link to="/blash">
              <h3>BLAST</h3>
            </router-link>
            <p>Sequence Similarity Search</p>
          </el-card>
        </el-col>
        <el-col :span="6" class="tool-col">
          <el-card class="tool-card">
            <router-link to="/go">
              <h3>GO</h3>
            </router-link>
            <p>Go Analysis</p>
          </el-card>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" style="margin-bottom: 10px; margin-top: 10px">
        <el-col :span="18">
          <p class="tools-title">Functions in this website:</p>
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="center">
        <el-col :span="6" class="tool-col">
          <el-card class="tool-card">
            <router-link to="/result/predictions">
              <h3>Interaction Prediction</h3>
            </router-link>
            <p>Mazie/Rice/Cotton/Wheat</p>
          </el-card>
        </el-col>
        <el-col :span="6" class="tool-col">
          <el-card class="tool-card">
            <router-link to="/search">
              <h3>Search</h3>
            </router-link>
            <p>Querying by JobID</p>
          </el-card>
        </el-col>
        <el-col :span="6" class="tool-col">
          <el-card class="tool-card">
            <router-link to="/result/heatmap">
              <h3>Visualization</h3>
            </router-link>
            <p>Heatmap/Gradient</p>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="center">
        <el-col :span="9" class="tool-col">
          <el-card class="tool-card">
            <router-link to="/tutorial">
              <h3>Tutorial</h3>
            </router-link>
            <p>User Guide</p>
          </el-card>
        </el-col>
        <el-col :span="9" class="tool-col">
          <el-card class="tool-card">
            <router-link to="/result/motifs">
              <h3>TF motifs</h3>
            </router-link>
            <p>Primitive Sequence</p>
          </el-card>
        </el-col>
        <!-- <el-col :span="6" class="tool-col">
          <el-card class="tool-card">
            <router-link to="/Browser">
              <h3>JBrowse</h3>
            </router-link>
            <p>Genome Browser</p>
          </el-card>
        </el-col> -->
      </el-row>
    </div>

    <!-- <div class="paper">
      <p class="paper-title">If use PlantCTCIP in pulication, please cite:</p>
      <p class="paper-text">
        XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
      </p>

    </div> -->

    <el-card class="bottom-card">
      <div style="margin-bottom: 50px; text-align: justify">
        <h2
          style="font-weight: bold; font-size: 30px; position: relative; display: inline-block"
          class="section-header"
        >
          Related Publications
        </h2>
        <p style="font-size: 20px; width: 100%">
          <strong>1. </strong> Peng Y, Xiong D, Zhao L, et al.
          <strong
            >Chromatin interaction maps reveal genetic regulation for quantitative traits in
            maize.</strong
          >
          Nature Communications 10: 2632(2019).<br />
          <strong>2. </strong> Li E, Liu H, Huang L, et al.
          <strong
            >Long-range interactions between proximal and distal regulatory regions in
            maize.</strong
          >
          Nature Communications 10: 2633(2019).<br />
          <strong>3. </strong> Sun Y, Dong L, Zhang Y, et al.
          <strong
            >3D genome architecture coordinates trans and cis regulation of differentially expressed
            ear and tassel genes in maize.</strong
          >
          Genome Biology 21(1): 1-25(2020).<br />
          <strong>4. </strong> Washburn J D, Mejia-Guerra M K, Ramstein G, et al.
          <strong>
            Evolutionarily informed deep learning methods for predicting relative transcript
            abundance from DNA sequence.</strong
          >
          Proceedings of the National Academy of Sciences of the United States of America 116(12):
          5542-5549(2019).<br />
          <strong>5. </strong> Tu, X., Mejía-Guerra, M.K., Valdes Franco, J.A. et al.
          <strong>
            Reconstructing the maize leaf regulatory network using ChIP-seq data of 104
            transcription factors.
          </strong>
          Nature Communications 11, 5089 (2020).
          <br />
          <strong>6. </strong> Tian, T., Wang, S., Yang, S. et al.
          <strong>
            Genome assembly and genetic dissection of a prominent drought-resistant maize germplasm.
          </strong>
          Nature Genetics 55, 496–506 (2023).
        </p>
      </div>
      <div class="shape-bottom-right">
        <img src="../assets/picture/v1.png" alt="Image Not Found" style="height: 300px" />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      list1: [],
      searchText: '',
      selectedOption: '',
      options: [
        { value: 'maize', label: 'Maize' },
        { value: 'rice', label: 'Rice' },
        { value: 'wheat', label: 'Wheat' },
        { value: 'cotton', label: 'Cotton' },
      ],
    }
  },
  methods: {
    turn2Search() {
      this.$router.push({
        path: `/search`,
        query: {
          taskID: this.searchText,
        },
      })
    },
    changeSelect() {
      if (this.selectedOption === 'maize') {
        this.$router.push({
          path: `/Expression/maize`,
        })
      } else if (this.selectedOption === 'rice') {
        this.$router.push({
          path: `/Expression/rice`,
        })
      } else if (this.selectedOption === 'wheat') {
        this.$router.push({
          path: `/Expression/wheat`,
        })
      } else if (this.selectedOption === 'cotton') {
        this.$router.push({
          path: `/Expression/cotton`,
        })
      }
    },
  },
  created() {},
}
</script>

<style scoped lang="less">
.components-layout-demo-basic {
  font-family: 'Open Sans', sans-serif;
  color: #333;
  width: 100%; /* 确保根容器宽度为 100% */
  overflow-x: hidden; /* 隐藏水平滚动条 */
  background-image: url('../img/gptBack4new.jpg'); /* 添加背景图片 */
  background-size: cover; /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center center; /* 背景图片居中显示 */

  .teacher-overview-welcome {
    width: 71%;
    margin: 0px auto;
    padding-top: 20px;

    .welcome {
      background: linear-gradient(to right, #add8e6 0%, #90ee90 100%);
      color: #000;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

      .welcome-title {
        font-size: 36px;
        color: #000;
      }

      .welcome-email {
        font-size: 20px;
        text-align: justify;
        text-indent: 2rem; /* 添加首行缩进 */
      }
    }
  }
  .top-text {
    margin-top: 20px;
    width: 71%; /* 调整宽度 */
    margin: 0 auto; /* 居中对齐 */
    margin-top: 20px;
    .img-select {
      height: 100%;
      .img-select-form {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
      }
      .custom-label {
        font-size: 22px !important; /* 调整标签字体大小 */
        font-weight: bold;
        color: #000;
      }
      .el-select,
      .el-input {
        margin-bottom: 10px;
      }
      .example-text {
        font-size: 22px;
      }
      .example-text2 {
        font-size: 18px;
        color: #0066ff;
        font-weight: bold;
      }
    }
  }

  .tools-section {
    width: 100%; /* 调整宽度比welcome部分稍微宽一点 */
    margin: 20px auto;

    .tools-title {
      font-size: 24px;
      font-weight: bold;
      text-align: left;
      color: #fff;
      background: hsl(120, 88%, 30%);
      padding: 10px 20px;
      border-radius: 5px 5px 5px 5px;
      display: inline-block;
      margin-bottom: -2px;
    }

    .tool-col {
      border-top: 7px solid #add8e6;
      /* --- 新增代码 Start --- */
      display: flex; /* 开启 flex 布局 */
      flex-direction: column; /* 垂直排列 */
      /* --- 新增代码 End --- */
    }

    .tool-card {
      background-color: #f8f9fa;
      color: #333;
      border-radius: 10px;
      padding: 15px;
      text-align: center;
      margin-bottom: 10px;

      /* --- 新增代码 Start --- */
      flex: 1; /* 让卡片自动撑满列的高度 */
      height: 100%; /* 确保占满高度 */
      display: flex; /* (可选) 如果你想让卡片里的内容也垂直居中/对齐 */
      flex-direction: column;
      justify-content: center; /* (可选) 内容垂直居中 */
      /* --- 新增代码 End --- */

      h3 {
        font-size: 26px;
        font-weight: bold;
        color: hsl(120, 95%, 23%);
      }
      p {
        font-size: 22px;
      }
    }
  }

  .paper {
    margin: 0 auto;
    width: 70%;
    .paper-title {
      font-size: 20px;
      font-weight: bold;
      color: hsl(120, 95%, 23%);
    }
    .paper-text {
      font-size: 18px;
      word-wrap: break-word; /* 确保文字自动换行 */
      text-align: justify;
    }
  }
}

.responsive-img {
  width: 100%;
  border-radius: 20px;
}

.bottom-card {
  text-align: center;
  width: 75%;
  margin: 0 auto;
  margin-bottom: 20px;
  /* background: linear-gradient(220.55deg, #0C3A2D 0%, #6D9773 100%);             */
  /* background: -webkit-linear-gradient(transparent, rgb(250, 250, 250) 0%); */

  color: #050505;
  border-radius: 30px;
  background: linear-gradient(120deg, #eaeaea 0%, #c0c0c0 100%);

  position: relative;

  z-index: 1;
}

.shape-bottom-right {
  position: absolute;
  right: 0;
  bottom: 0;
  max-width: 40%;
  z-index: -1;
  opacity: 0.3;
}
</style>
